import React, { forwardRef } from 'react';
import cx from "classnames";
import styled from 'styled-components';
import IBuildrProps from 'src/utilities/IBuildrProps';

interface ILPLDisclosureProps extends IBuildrProps {
    data: any;
}

export default styled(forwardRef(({ cmsId, editorClassObj, className, data }: ILPLDisclosureProps, ref: any) => {
    return (
        <div data-id={cmsId} className={cx(editorClassObj, className, 'p-4', 'p-sm-8')} ref={ref}>
            <p>
                <strong>Securities and advisory services are offered through LPL Financial (LPL), a registered investment advisor and broker-dealer (member <a href="http://www.finra.org/">FINRA</a>/<a href="http://www.sipc.org/">SIPC</a>).</strong>  Insurance products are offered through LPL or its licensed affiliates. Mountain America Credit Union and Mountain America Investment Services <u><strong>are not</strong></u> registered as a broker-dealer or investment advisor. Registered representatives of LPL offer products and services using Mountain America Investment Services, and may also be employees of Mountain America Credit Union. These products and services are being offered through LPL or its affiliates, which are separate entities from, and not affiliates of, Mountain America Credit Union or Mountain America Investment Services. Securities and insurance offered through LPL or its affiliates are:
            </p>

            <table className="details-table mb-3">
                <tbody>
                    <tr>
                        <td>Not Insured by NCUA or Any Other Government Agency</td>
                        <td>Not Credit Union Guaranteed</td>
                    </tr>
                    <tr>
                        <td>Not Credit Union Deposits or Obligations</td>
                        <td>May Lose Value</td>
                    </tr>
                </tbody>
            </table>

            <p>
                This site is designed for U.S. residents only. The services offered within this site are available exclusively through our U.S. Investment Representatives. LPL Financial U.S. Investment Representatives may only conduct business with residents of the states for which they are properly registered. Please note that not all of the investments and services mentioned are available in every state.
            </p>
            <p className="mb-0">
                Insurance products are not deposits, not an obligation of and not guaranteed by Mountain America Credit Union. Insurance products are not protected by the NCUA, may be subject to risk and, in the case of life insurance, may go down in value. Any insurance required as a condition of an extension of credit need not be purchased from the credit union and may be purchased from an agent or insurance company of the member's choice. Insurance products are not exclusive to Mountain America Credit Union members. Business conducted with Mountain America Insurance Services, LLC is separate and distinct from any business conducted with the credit union. Mountain America Insurance Services, LLC is a subsidiary of Mountain America Credit Union.
            </p>
        </div>
    )
}))`
    font-size: 14px;
    color: ${props => props.theme.darkGrayText};
    background-color: ${props => props.theme.gray150};

    .details-table {
        border-top: 1px solid ${props => props.theme.gray550};
        border-left: 1px solid ${props => props.theme.gray550};
        text-align: center;

        td {
            padding: 10px 15px;
            border-bottom: 1px solid ${props => props.theme.gray550};
            border-right: 1px solid ${props => props.theme.gray550};
            font-weight: 700;
        }
    }
`;